declare namespace $ {

	export class $bog_theme_picker_row extends $mol_button_minor {
		focused_str( ): string
		hover( next?: any ): any
		theme_name( ): string
		title( ): ReturnType< $bog_theme_picker_row['theme_name'] >
		attr( ): ({ 
			'bog_theme_picker_row_focused': ReturnType< $bog_theme_picker_row['focused_str'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		event( ): ({ 
			pointerenter( next?: ReturnType< $bog_theme_picker_row['hover'] > ): ReturnType< $bog_theme_picker_row['hover'] >,
		})  & ReturnType< $mol_button_minor['event'] >
	}
	
}

//# sourceMappingURL=row.view.tree.d.ts.map